import {DadosSobreFornecedor} from './DadosSobreFornecedor'
import {Pedido} from './Pedido'

export class PedidoFechadoParaResumo {
    fornecedor?: DadosSobreFornecedor | null = null
    pedido?: Pedido | null = null
}